<template>
    <div class="block_center">
        <div class="SoftwareSupportDetail">
            <div class="crumbs">
                <span>服务与支持</span>
                <img src="../../../../assets/image/crumbs_arrow.png" alt="">
                <span>软件支持</span>
                <img src="../../../../assets/image/crumbs_arrow.png" alt="">
                <span class="title">{{ title }}</span>
            </div>
            <div class="titleInfo">
                <div class="title_name">{{ title }}</div>
                <div class="published">峰岭科技在线支持发表于知识库</div>
                <div class="published_avatar">
                    <img src="../../../../assets/image/SoftwareSupportDetail_avatar.png" alt="">
                </div>
                <div class="published_people">SummitSolid</div>
                <div class="published_time">修改于 Tue, 27 Sep 2023 在 04:13 AM</div>
            </div>
            <div class="content_img">
                <img src="../../../../assets/image/SoftwareSupportDetail_content.png" alt="">
            </div>
            <div class="content_one">
                内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
            </div>
            <div class="content">
                内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
            </div>
            <div class="small_title">
                标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题
            </div>
            <div class="content content_two">
                内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
            </div>
            <ul class="documents_list">
                <li>
                    <img src="../../../../assets/image/drop.png" alt="">
                    <span>相关文档相关文档相关文档相关文档相关文档相关文档相关文档相关文档相关文档</span>
                </li>
                <li>
                    <img src="../../../../assets/image/drop.png" alt="">
                    <span>相关文档相关文档相关文档相关文档相关文档相关文档相关文档相关文档相关文档</span>
                </li>
                <li>
                    <img src="../../../../assets/image/drop.png" alt="">
                    <span>相关文档相关文档相关文档相关文档相关文档相关文档相关文档相关文档相关文档</span>
                </li>
                <li>
                    <img src="../../../../assets/image/drop.png" alt="">
                    <span>相关文档相关文档相关文档相关文档相关文档相关文档相关文档相关文档相关文档</span>
                </li>
                <li>
                    <img src="../../../../assets/image/drop.png" alt="">
                    <span>相关文档相关文档相关文档相关文档相关文档相关文档相关文档相关文档相关文档</span>
                </li>
            </ul>
            <div class="content_img_two">
                <img src="../../../../assets/image/SoftwareSupportDetail_content_two.png" alt="">
            </div>
            <div class="small_title small_title_two">
                标题标题标题标题标题
            </div>
            <div class="content content_three">
                内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
            </div>
            <div class="content content_four">
                内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
            </div>
            <InterestPlate :interestedList="interestedList" class="InterestPlate"></InterestPlate>
        </div>
    </div>
</template>

<script>
import InterestPlate from "../InterestPlate/index.vue"
export default {
    components: {
        InterestPlate
    },
    data() {
        return {
            title: "构建人字顶房屋",
            interestedList: [
                [
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶1",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    },
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶2",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    },
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶3",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    }
                ],
                [
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶5",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    },
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶6",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    },
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶7",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    }
                ],
                [
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶9",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    },
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶10",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    },
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶11",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    }
                ],
                [
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶13",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    },
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶14",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    },
                    {
                        img: require("../../../../assets/image/interested_img.png"),
                        title: "构建复杂屋顶15",
                        publisher: "fenglingyihao",
                        time: "18 Sep 2023",
                        introduction: "简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简。"
                    }
                ]
            ],
        };
    },
    mounted() {

    },
    watch: {

    },
    methods: {

    }
};
</script>
<style scoped lang="scss" scoped>
.block_center {
    margin-top: 60px;
    display: flex;
    justify-content: center;

    .SoftwareSupportDetail {
        padding-top: 44px;
        width: 1200px;
    }

    .crumbs {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 16px;
        color: rgba(144, 147, 153, 1);
        text-align: left;
        vertical-align: top;
        margin-bottom: 80px;

        img {
            height: 18px;
            margin: 0 20px;
        }

        .title {
            color: rgba(48, 49, 51, 1);
        }
    }

    .titleInfo {

        .title_name,
        .published,
        .published_avatar,
        .published_people,
        .published_time {
            display: flex;
            justify-content: center;
        }

        .title_name {
            font-size: 60px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 84px;
            color: rgba(67, 207, 124, 1);
            text-align: center;
            vertical-align: top;
            margin-bottom: 18px;
        }

        .published {
            font-size: 20px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 32px;
            color: rgba(105, 107, 128, 1);
            text-align: center;
            vertical-align: top;
            margin-bottom: 64px;
        }

        .published_avatar {
            margin-bottom: 8px;

            img {
                height: 48px;
            }
        }

        .published_people {
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(67, 207, 124, 1);
            text-align: center;
            vertical-align: top;
            margin-bottom: 2px;
        }

        .published_time {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(166, 167, 178, 1);
            text-align: center;
            vertical-align: top;
            margin-bottom: 62px;
        }
    }

    .content_img {
        margin-bottom: 194px;

        img {
            height: 775px;
        }
    }

    .content_one {
        font-size: 20px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 32px;
        color: rgba(105, 107, 128, 1);
        text-align: left;
        vertical-align: top;
        margin-bottom: 30px;
    }

    .content {
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(114, 115, 132, 1);
        text-align: left;
        vertical-align: top;
        margin-bottom: 100px;
    }

    .small_title {
        font-size: 32px;
        font-weight: 500;
        letter-spacing: 0px;
        line-height: 48px;
        color: rgba(67, 207, 124, 1);
        text-align: left;
        vertical-align: top;
    }

    .content_two {
        margin-bottom: 200px;
    }

    .documents_list {
        margin-bottom: 72px;

        li {
            display: flex;
            align-items: center;
            font-size: 15px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(109, 119, 131, 1);
            text-align: left;
            vertical-align: top;
            margin-bottom: 10px;

            img {
                height: 8px;
                margin-right: 20px;
            }
        }
    }

    .content_img_two {
        margin-bottom: 72px;

        img {
            height: 554px;
        }
    }

    .small_title_two {
        margin-bottom: 18px;
    }

    .content_three {
        margin-bottom: 20px;
    }

    .content_four {
        margin-bottom: 330px;
    }

    .InterestPlate{
        margin-bottom: 219px;
    }
}
</style>